import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-order-followup-report',
  templateUrl: './order-followup-report.component.html',
  styleUrls: ['./order-followup-report.component.css']
})
export class OrderFollowupReportComponent extends BaseCrudComponent {

    translations:any;
    header:any;
    momentjs: any = moment;
    curr_date:any;
    dstart:any;
    dend:any;
    zones:any;
    theaders:any;

    offline_date = '';
    zoom = 15;
    track_lat:any;
    track_lng:any;

    exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

    activeFilter:any = null;

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
      ) {
          super(srv, modalService, storage, router);
          this.read_url = 'Portal/TrackOrders';
          this.header = {};
          this.zones = [];

          this.theaders = [
              { field: 'id', header: 'ID', sortable:true, sortfield:'id', styleC:{'text-align':'center'}, width:{'width.px': 90}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'clientCode', header: 'Código Cliente', sortable:true, sortfield:'clientCode', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'clientName', header: 'Cliente', sortable:true, sortfield:'clientName', styleC:{'text-align':'center'}, width:{'width.px': 250}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'agentCode', header: 'Código Agente', sortable:true, sortfield:'agentCode', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'agentName', header: 'Agente', sortable:true, sortfield:'agentName', styleC:{'text-align':'center'}, width:{'width.px': 250}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'sequence', header: 'No. Hiviforce', sortable:true, sortfield:'sequence', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'sapDocument', header: 'No. SAP', sortable:true, sortfield:'sapDocument', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'authorizedTerm', header: 'Forma de Pago', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 300}, isColor:false, pre:'', pos:'', total:''},
              { field: 'observation', header: 'Observación', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 300}, isColor:false, pre:'', pos:'', total:''},
              { field: 'sapMessage', header: 'Mensaje SAP', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 300}, isColor:false, pre:'', pos:'', total:''},
              { field: 'type', header: 'Tipo', sortable:false, sortfield:'type', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'classType', header: 'Clase', sortable:false, sortfield:'classType', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'subtotal', header: 'Subtotal', sortable:false, sortfield:'subtotal', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'$', pos:'', total:''},
              { field: 'discount', header: 'Descuento', sortable:false, sortfield:'discount', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'$', pos:'', total:''},
              { field: 'total', header: 'Total', sortable:false, sortfield:'total', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'$', total:''},
              { field: 'tax', header: 'Impuesto', sortable:false, sortfield:'tax', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'$', total:''},
              { field: 'ship', header: 'Flete', sortable:false, sortfield:'ship', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'$', total:''},
              { field: 'deviceTimeStamp', header: 'Fecha Dispositivo', sortable:true, sortfield:'deviceTimeStamp', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:''},
              { field: 'hiviTimeStamp', header: 'Fecha Creación Hiviforce', sortable:true, sortfield:'hiviTimeStamp', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:''},
              { field: 'approveTimeStamp', header: 'Fecha Aprobación', sortable:true, sortfield:'approveTimeStamp', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:''},
              { field: 'sapTimeStamp', header: 'Fecha Creación SAP', sortable:true, sortfield:'sapTimeStamp', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:''}
              
          ];
      }

    ngOnInit() {
        this.dstart = this.momentjs().tz('America/Guayaquil');
        this.dstart.day(1);
        //this.f_datefrom = this.dstart.format('YYYY-MM-DD');
        this.f_datefrom = {year:this.dstart.year(), month:this.dstart.month()+1, day:this.dstart.date()};

        this.dend = this.momentjs().tz('America/Guayaquil');
        this.dend.day(5);
        //this.f_dateto = this.dend.format('YYYY-MM-DD');
        this.f_dateto = {year:this.dend.year(), month:this.dend.month()+1, day:this.dend.date()};

        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        //this.curr_date = this.momentjs().tz('America/Guayaquil');

        this.translate.getTranslation(this.translate.currentLang)
          .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
          });
    }

    public getList(){
        var qst = this.read_url;
        var to:any;

        this.rows = [];

        var start = this.momentjs(this.getISODate(this.f_datefrom));
        var end = this.momentjs(this.getISODate(this.f_dateto));
        
        if( end.isBefore(start) ){
            //Swal.fire('Fecha Hasta debe ser mayor a Fecha Desde', '', 'error');
            Swal.fire('Fecha Hasta debe ser mayor o igual a Fecha Desde', '', 'error');
            return;
        }

        to = {
            // startDate: '2022-11-01',
            // endDate: '2022-11-30',
            startDate: this.getISODate(this.f_datefrom),
            endDate: this.getISODate(this.f_dateto),
            isActive: this.activeFilter
        };

        this.loadingList = true;
        this.srv.postCall(qst, to).subscribe(x => {
            this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.rawdata = rs;
                this.rows = this.rawdata;
            }
        });
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'seg_pedidos_'+this.curr_date).subscribe(() => {
          // save started
        });
    }

}
